import * as React from 'react';
import { StyledChildrenContainer } from './styles/ChildrenWrapperStyles';
export var JustifyContentType;
(function (JustifyContentType) {
    JustifyContentType["FlexStart"] = "flex-start";
    JustifyContentType["Center"] = "center";
})(JustifyContentType || (JustifyContentType = {}));
var ChildrenWrapper = function (_a) {
    var children = _a.children, _b = _a.justifyContent, justifyContent = _b === void 0 ? JustifyContentType.FlexStart : _b, _c = _a.testId, testId = _c === void 0 ? 'children-container' : _c, className = _a.className;
    return (React.createElement(StyledChildrenContainer, { "data-testid": testId, justifyContent: justifyContent, className: className }, children));
};
export default ChildrenWrapper;
//# sourceMappingURL=ChildrenWrapper.js.map